import React, { useEffect, useRef } from "react";
import "./bracelets.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import imgLeft1 from "./images/layerLeft1.webp";
import imgLeft2 from "./images/layerLeft2.webp";
import imgRight1 from "./images/layerRight1.webp";
import imgRight2 from "./images/layerRight2.webp";
import earringImg from "./images/videoProduct.mp4";

export default function Bracelets() {
  gsap.registerPlugin(ScrollTrigger);

  let col1Ref = useRef(null);
  let col2Ref = useRef(null);
  let col3Ref = useRef(null);
  let col4Ref = useRef(null);
  let titleRef = useRef(null);

  return (
    <div className="bracelets-main">
      <div className="component-header" ref={(el) => (titleRef = el)}>
        <p>KAJDANY</p>
      </div>
      <div className="component-images">
        <div className="component-column column-left">
          <div className="left-content">
            <div className="left-image-1" ref={(el) => (col2Ref = el)}>
              <img
                src={
                  "https://cdn.media.amplience.net/i/teilor/Natalia Stanga 3"
                }
                alt=""
              />
            </div>
            <div className="left-image-2" ref={(el) => (col1Ref = el)}>
              <img
                src={
                  "https://cdn.media.amplience.net/i/teilor/Natalia Stanga 33"
                }
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="component-column column-middle">
          <div className="middle-content">
            <div className="middle-image" />
            <a href="https://www.teilor.pl/bransoletka-z-18k-zoltego-zlota-z-bezbarwnymi-diamentami-o-masie-16-21ct-i-kolorowymi-diamentami-o-masie-3-8ct-108233.html">
              <video
                className="middle-video"
                playsinline="true"
                autoplay="true"
                loop="true"
                muted="true"
              >
                <source
                  src="https://cdn.media.amplience.net/v/teilor/108233_1/mp4_720p"
                  type="video/mp4"
                />
              </video>
            </a>
          </div>
        </div>
        <div
          className="component-column column-right"
          ref={(el) => (col3Ref = el)}
        >
          <div className="right-content">
            <div className="right-image-1" ref={(el) => (col3Ref = el)}>
              <img
                src={
                  "https://cdn.media.amplience.net/i/teilor/Natalia Dreapta 3"
                }
                alt=""
              />
            </div>
            <div className="right-image-2" ref={(el) => (col4Ref = el)}>
              <img
                src={
                  "https://cdn.media.amplience.net/i/teilor/Natalia Dreapta 33"
                }
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div className="component-content">
        <div className="component-content-title bracelets-content-title">
          <p>przyciągająca wzrok </p>
        </div>
        <div className="component-content-text">
          <p>
            {" "}
            Brylanty i kamienie tłoczące się wokół Twoich nadgarstków. Te ozdoby
            wibrują swoją jaskrawością, a ich zadaniem jest robić wrażenie. Przy
            każdej okazji.
          </p>
        </div>
      </div>
    </div>
  );
}
